module.exports = {"pathContext":{"name":"UpdateStockTransferReportRecipientInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"email","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-update-stock-transfer-report-recipient-input.json
// module id = 1593
// module chunks = 58447293763160